import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import IndexPage from 'flarum/forum/components/IndexPage';
import sortTags from 'ext:flarum/tags/common/utils/sortTags';

/**
 * Sotto il riquadro FORUM del layout: il menu ("View active topics") e le briciole di pane del tema phpBB
 * (Board index → categoria → forum), calcolate dalla pagina corrente.
 */
export default class ForumHead extends Component {
  view() {
    return [m("nav", {
      className: "ForumHead-menu",
      "aria-label": "Forum"
    }, m("ul", null, m("li", null, m(Link, {
      href: app.route('index')
    }, "View active topics")))), m("nav", {
      className: "ForumHead-breadcrumbs",
      "aria-label": "Breadcrumb"
    }, m(Icon, {
      name: "fas fa-house"
    }), this.trail().map((item, i) => [i > 0 && m(Icon, {
      name: "fas fa-arrow-right"
    }), item]))];
  }
  trail() {
    const items = [m(Link, {
      href: app.route('tags')
    }, "Board index")];
    let tags = [];
    if (app.current.matches(DiscussionPage)) {
      const discussion = app.current.get('discussion');
      tags = sortTags((discussion?.tags?.() || []).filter(Boolean));
    } else if (app.current.matches(IndexPage) && app.currentTag) {
      const tag = app.currentTag();
      if (tag) tags = tag.parent() ? [tag.parent(), tag] : [tag];
    }
    return items.concat(tags.map(tag => m(Link, {
      href: app.route.tag(tag)
    }, tag.name())));
  }
}
flarum.reg.add('runeaudio-theme', 'forum/components/ForumHead', ForumHead);